import { Dispatch, SetStateAction } from "react";
import { OnPeriodDayChange, OnSavingsNameChange } from "../../components/handlers";

export const OnPeriodDayNumberClick = (
  index: number,
  setSelectedPeriodDayNumber: Dispatch<SetStateAction<number>>,
  setSavingsAgreementPeriodDayNumber?: (periodDayNumber: number) => void,
) => {
  setSelectedPeriodDayNumber(index);
  OnPeriodDayChange(index, setSavingsAgreementPeriodDayNumber);
};

export const OnAdvisorClick = (index: number, setSavingsAgreementAdvisorCarriedOut?: (advisorCarriedOut: boolean) => void) => {
  const advisorCarriedOut = index === 1;
  setSavingsAgreementAdvisorCarriedOut?.(advisorCarriedOut);
};

export const OnAgreementNameChange = (
  name: string,
  setAgreementName: Dispatch<SetStateAction<string>>,
  setSavingsAgreementName?: (name: string) => void,
) => {
  setAgreementName(name);
  OnSavingsNameChange(name, setSavingsAgreementName);
};
